import { ComponentStyleConfig, cssVar } from '@chakra-ui/react';

const $startColor = cssVar('skeleton-start-color');
const $endColor = cssVar('skeleton-end-color');
const $M30 = cssVar('chakra-colors-M-30');

export const Skeleton: ComponentStyleConfig = {
  baseStyle: {
    borderRadius: 4,
    _light: {
      [$startColor.variable]: 'rgba(235, 235, 235, 0.3)', // M30 with 0.3 opacity
      [$endColor.variable]: $M30.reference,
    },
    _dark: {
      [$startColor.variable]: 'rgba(41, 41, 41, 0.3)', // M30 with 0.3 opacity
      [$endColor.variable]: $M30.reference,
    },
  },
};
